import React, { useState,useRef,useEffect } from "react";
import { PlusOutlined, MinusOutlined } from "@ant-design/icons";
import { useNavigate, useLocation } from "react-router-dom";
import "./teamAssignmentCard.scss";
import TeamAssignmentCardStatsView from "../teamAssignmentCardStatsView";
import { getFieldStyle } from "../../themes";

export default function TeamAssignmentCard({
    data,
    all,
    index,
    nujobsPost = false
}) {
    const navigate = useNavigate();
    const inputRef = useRef(null);
    const [teamAssignmentCardOpen, setTeamAssignmentCardOpen] = useState(false);
    const location = useLocation();
    const pathSegments = location.pathname.split("/");
    const parentPath = pathSegments[1];
    //console.log("Team Assignment Card",data)

    useEffect(() => {
        setTeamAssignmentCardOpen(false);
    }, [data]);
    
    const focusInputField = () => {
        if (inputRef.current) {
            inputRef.current.focus();
        }
    };

    const getResumeQuality =(qualityStatus)=>{
        const candidateMap2 = new Map([
            ["Resumes Partial Suitable", qualityStatus?.numpartialsuitable],
            ["Resumes Good Match", qualityStatus?.numgoodmatch],
            ["Resumes Not Suitable", qualityStatus?.numnotsuitable],
            ["Resume Average", qualityStatus?.numaverage],
            ["Resumes Below Average", qualityStatus?.numbelowaverage],
            ["Resumes Above Average", qualityStatus?.numaboveaverage],
        ]);
        return candidateMap2
    }
    const getCandidateStatusMap1 =(candidateStatus)=>{
        var candidateMap1;
        if(all){

            candidateMap1 = new Map([
                ["By Team", candidateStatus?.NoOfResumesSourced],
                ["NuJobs", candidateStatus?.NoOfResumesNuJobs],
                ["Automation", candidateStatus?.NoOfResumesAutomation],
                ["By Links", candidateStatus?.NoOfResumesLinks],
                ["By Vendors", candidateStatus?.NoOfResumesVendors],                  
                ["To Be Called", candidateStatus?.NoOfResumesToBeCalled],
                ["Not Picking", candidateStatus?.NoOfResumesNotPicking],
                ["Disconnected", candidateStatus?.NoOfResumesDisconnected],
                ["Busy", candidateStatus?.NoOfResumesBusy],
                ["OOS", candidateStatus?.NoOfResumesOOS],
                ["SwitchOFF", candidateStatus?.NoOfResumesSwitchOFF],
                ["Call Later", candidateStatus?.NoOfResumesCallLater],
                ["Not Interested", candidateStatus?.NoOfResumesNotInterested],
                ["Not Looking", candidateStatus?.NoOfResumesNotLooking],
                ["Not Suitable", candidateStatus?.NoOfResumesNotSuitable], 
                ["Resume Pending", candidateStatus?.NoOfResumesPending],                               
                ["Interview within 6 months", candidateStatus?.NoOfResumesInterviewdIn6Months]
            ]);
        }else{
            candidateMap1 = new Map([
                ["By Team", candidateStatus?.NoOfResumesSourced],
                ["NuJobs", candidateStatus?.NoOfResumesNuJobs],
                ["Automation", candidateStatus?.NoOfResumesAutomation],
                ["By Links", candidateStatus?.NoOfResumesLinks],
                ["By Vendors", candidateStatus?.NoOfResumesVendors],                
                ["To Be Called", candidateStatus?.NoOfResumesToBeCalled],
                ["Not Picking", candidateStatus?.NoOfResumesNotPicking],
                ["Disconnected", candidateStatus?.NoOfResumesDisconnected],
                ["Busy", candidateStatus?.NoOfResumesBusy],
                ["OOS", candidateStatus?.NoOfResumesOOS],
                ["SwitchOFF", candidateStatus?.NoOfResumesSwitchOFF],
                ["Call Later", candidateStatus?.NoOfResumesCallLater],
                ["Not Interested", candidateStatus?.NoOfResumesNotInterested],
                ["Not Looking", candidateStatus?.NoOfResumesNotLooking],
                ["Not Suitable", candidateStatus?.NoOfResumesNotSuitable],
                ["Resume Pending", candidateStatus?.NoOfResumesPending],
                ["Interview within 6 months", candidateStatus?.NoOfResumesInterviewdIn6Months]
            ]);
        }

        return candidateMap1
    } 
    const getCandidateStatusMap2 =(candidateStatus)=>{
        const candidateMap2 = new Map([
            ["JD Needed", candidateStatus?.NoOfResumesJDNeeded],
            ["Available", candidateStatus?.NoOfResumesAvailable],
            ["Available_HCTC", candidateStatus?.NoOfResumesAvailableHCTC],
            ["Available_HNP", candidateStatus?.NoOfResumesAvailableHNP],
            ["Direct Payroll", candidateStatus?.NoOfResumesClientDirectPayroll],
            ["Already Applied", candidateStatus?.NoOfResumesAlreadyApplied],
            ["Already Got Call", candidateStatus?.NoOfResumesAlreadyGotCall],
            ["Interview before 6 months", candidateStatus?.NoOfResumesInterviewdBefore6Months],
            ["Location Issue", candidateStatus?.NoOfResumesLocationIssue]
        ]);
        return candidateMap2
    }

    const getResumeStatus =(resumeStatus)=>{
        const resumeMap = new Map([
            ["Shared", resumeStatus?.NoOfShared],
            ["Review Pending", resumeStatus?.NoOfReviewPending],
            ["To Be Shared", resumeStatus?.NoOfToBeShared],
            ["FB Pending", resumeStatus?.NoOfFBPending],
            ["Client FB Pending", resumeStatus?.NoOfClientFBPending],
            ["Screen Rejected", resumeStatus?.NoOfScreenRejected],
            ["Screen Rejected HCTC", resumeStatus?.NoOfScreenRejectedHCTC],            
            ["Screen Rejected HNP", resumeStatus?.NoOfScreenRejectedHNP],            
            ["Duplicate", resumeStatus?.NoOfDuplicate],
            ["Interview Rejected", resumeStatus?.NoOfInterviewRejected],
            ["Screen Selected", resumeStatus?.NoOfScreenSelected],
            ["Screen Partial Suitable", resumeStatus?.NoOfScreenPartialSuitable]            
        ]);
        return resumeMap
    }

    const getInterviewType =(interviewType)=>{
        const typeMap = new Map([
            ["L0 Interview", interviewType?.NoOfInterviewTypeL0],
            ["L1 Interview", interviewType?.NoOfInterviewTypeL1],
            ["L2 Interview", interviewType?.NoOfInterviewTypeL2],
            ["Customer Interview", interviewType?.NoOfInterviewTypeCustomer],
            ["HR Interview", interviewType?.NoOfInterviewTypeHR],
            ["MgMT Interview", interviewType?.NoOfInterviewTypeMGMT]
        ]);
        return typeMap
    } 
    const getInterviewAction =(interviewAction)=>{
        const actionMap = new Map([
            ["To Be Scheduled", interviewAction?.NoOfInterviewActionToSchedule],
            ["Schedule", interviewAction?.NoOfInterviewActionScheduled],
            ["To Be Rescheduled", interviewAction?.NoOfInterviewActionToReSchedule],
            ["Reschedule", interviewAction?.NoOfInterviewActionRescheduled],
            ["Cancel", interviewAction?.NoOfInterviewActionCancelled],
            ["Done", interviewAction?.NoOfInterviewActionDone]
        ]);
        return actionMap
    }     
        
    const getInterviewStatus =(interviewStatus)=>{
        const statusMap = new Map([
            ["YTBS", interviewStatus?.NoOfInterviewStatusYTBS],
            ["YTBRS", interviewStatus?.NoOfInterviewStatusYTBRS],
            ["Scheduled", interviewStatus?.NoOfInterviewStatusScheduled],
            ["ReScheduled", interviewStatus?.NoOfInterviewStatusReScheduled],
            ["Cancelled", interviewStatus?.NoOfInterviewStatusCancelled],
            ["No Panel", interviewStatus?.NoOfInterviewStatusNoPanel],
            ["Candidate Drop", interviewStatus?.NoOfInterviewStatusCandidateDrop],
            ["Candidate NP", interviewStatus?.NoOfInterviewStatusCandidateNP],
            ["Panel Not Joined", interviewStatus?.NoOfInterviewStatusPanelNotJoined],
            ["Done/IFP", interviewStatus?.NoOfInterviewStatusDone],
            ["No Show", interviewStatus?.NoOfInterviewStatusNoShow],
            ["Selected", interviewStatus?.NoOfInterviewStatusSelected],
            ["Hold", interviewStatus?.NoOfInterviewStatusHold],
            ["Rejected", interviewStatus?.NoOfInterviewStatusRejected],
            ["Final Select", interviewStatus?.NoOfInterviewStatusFinalSelect]
        ]);
        return statusMap
    } 

    const getSelectionStatus =(selectionStatus)=>{
        const statusMap = new Map([
            ["Selected", selectionStatus?.numfinalselected],
            ["Offered", selectionStatus?.numoffered],
            ["Offer Declined", selectionStatus?.numdeclined],
            ["Joined", selectionStatus?.numjoined],
            ["Joined Elsewhere", selectionStatus?.numjoinedelsewhere],
            ["Offer On Hold", selectionStatus?.numofferonhold],
            ["BGV Ongoing", selectionStatus?.numdocumentationongoing],
            ["BGV Fail", selectionStatus?.numdocumentproblems]           
        ]);
        return statusMap
    }       

    const handleJDClick = (id) => {
      if(nujobsPost){
         navigate(`/${parentPath}/${id}/nujobs`);
      }else{
         navigate(`/${parentPath}/${id}`);
      } 
    };
    return (

    <div className= "teamAssignmentCard-wrapper">
      <div className="teamAssignmentCard-JD-title-wrapper">
        <div
          className="param_wrapper_0"
          onClick={() => setTeamAssignmentCardOpen((prev) => !prev)}
        >
          <div className="toggle-dropdown-btn">
            { !nujobsPost ?<>
              {teamAssignmentCardOpen ? <MinusOutlined /> : <PlusOutlined />}</>
              :<></>
            }
          </div>
          <div
            className="param_wrapper_0_0"
            onClick={() => handleJDClick(data.qhcompanyjid)}
            style={{ cursor: "pointer" }}
          >
            {
              data.jd.JDProject.ReqType != "customer_project"?
              <>
                {index}{". "}
                <span className="param_info">
                  {"[ " + data.client + " / "}
                  {data.ta + " ] "}
                </span>
                <span className="param_info">
                  {
                    "[ " + data.jd.JDDetails.JobType.charAt(0)+ " ] "
                  }
                </span>                 
              </>
              :<>
                {index}{". "}
                <span className="param_info">
                  {"[ " + data.client + " / "}
                  {data.ta + " ] "}
                </span>
                <span className="param_info">
                  {
                    data.jd.JDDetails.JobType == "Contract"?
                    <>
                        {"[ " + data.jd.JDClient.ClientJobType + " / "}
                        {data.jd.JDDetails.JobType + " ] "}                    
                    </>
                    :<>
                       {"[ " + data.jd.JDClient.ClientJobType + " ] "}
                    </>
                  }
                </span>                                  
              </>
            }
                <span className="param_info">
                  {"[ " + data.jd.JDRequired?.MinExperience +"- "+ data.jd.JDRequired?.MaxExperience+ " Yr ] "}
                </span> 
                <span className="param_info">
                  {"[ " + data.jd.JDRequired?.NoticePeriod+ " D ]"}
                </span>     
                <span className="param_info">
                  {"[ " + data.jd.JDProject?.MinCtc +" - "+ data.jd.JDProject?.MaxCtc+ " LPA ] "}
                </span>                                                            
                <span className="param_info">
                  {" [" + data.jd.QhCompanyJID + "]  "}{" "}
                </span>
                <span
                  className="param_info jd_priority"
                  style={getFieldStyle("jdPriority", data.priority)}
                >
                  {" [" + data.priority + "]      "}{" "}
                </span>{" "}
                {data.title}                  
          </div>
          <div className="param_wrapper_0_1">
            <div
              style={{
                backgroundColor: "#fff",
                marginRight: "5px",
                borderRadius: "6px",
              }}
            >           
              <div
                className="jd_status"
              >
                {data.numapplication == 0 ? "(0)" : "("+data.numapplication + ")"}
              </div>
            </div>            
            <div
              style={{
                backgroundColor: "#fff",
                marginRight: "5px",
                borderRadius: "6px",
              }}
            >           
            <div
                className="jd_status"
                style={getFieldStyle("jdPermission", data.jd.JDDetails.JobPermission)}
              >
                {data.jd.JDDetails.JobPermission}
              </div>   
            </div>
            <div
              style={{
                backgroundColor: "#fff",
                marginRight: "5px",
                borderRadius: "6px",
              }}
            >
              <div
                className="jd_status"
                style={getFieldStyle("jdStatus", data.jdstatus)}
              >
                {data.jdstatus}
              </div>
            </div>
            <span className="param_info_end">
              {data.spoc == "" ? "SPOC : Not Assigned" : "SPOC : " + data.spoc}
            </span>
          </div>
        </div>
      </div>

      {teamAssignmentCardOpen && !nujobsPost ? (
        data.numapplication == 0 ? (
          <></>
        ) : (
          <div className="teamAssignmentCard-Stats-wrapper">
            <TeamAssignmentCardStatsView
              data={getResumeQuality(data?.resumequalitystatus)}
              type={"Resume Quality"}
              analyticsAction={"IMPROVE"}
              jdStatus={data.jdstatus}
            />
            <TeamAssignmentCardStatsView
              data={getCandidateStatusMap1(data?.candidatestatus)}
              type={"Candidate Status"}
              analyticsAction={"ACTION NEEDED"}
              jdStatus={data.jdstatus}
            />
            <TeamAssignmentCardStatsView
              data={getCandidateStatusMap2(data?.candidatestatus)}
              type={"Candidate Status"}
              analyticsAction={"ACTION NEEDED"}
              jdStatus={data.jdstatus}
            />
            <TeamAssignmentCardStatsView
              data={getResumeStatus(data?.resumestatus)}
              type={"Resume Status"}
              analyticsAction={"ACTION NEEDED"}
              jdStatus={data.jdstatus}
            />
            <TeamAssignmentCardStatsView
              data={getInterviewType(data?.interviewtype)}
              type={"Interview Type"}
              analyticsAction={"IMPROVE"}
              jdStatus={data.jdstatus}
            />
            <TeamAssignmentCardStatsView
              data={getInterviewStatus(data?.interviewstatus)}
              type={"Interview Status"}
              analyticsAction={"ACTION NEEDED"}
              jdStatus={data.jdstatus}
            />
            <TeamAssignmentCardStatsView
              data={getSelectionStatus(data?.offers)}
              type={"Selections"}
              analyticsAction={"FOLLOW-UP"}
              jdStatus={data.jdstatus}
            />
          </div>
        )
      ) : (
        <></>
      )}
    </div>
  );
}
